// src/components/NotificationBell.tsx
import React, { useContext, useEffect, useRef, useState } from "react";
import { FaBell } from "react-icons/fa";
import { useWebSocketNotifications } from "../hooks/WebSocketHook";
import { INotificationRequest } from "../lib/interfaces/NotificationInterface";
import { AuthContext } from "./AuthContextComponent";
import { ROUTES } from "../lib/enums";
import { Link } from "react-router-dom";

type NotifyResponse = {
  userId: string;
  userFName: string;
  userMName: string;
  userLName: string;
  userEmail: string;
  notificationMessage: string;
  title: string;
  notifyBulkDetailsInfo?: [
    {
      submittedOn: string;
      monetaryValue: string;
      batchNumber: string;
    }
  ];
  respCode: number;
  respMsg: string;
};

const NotificationBell = () => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [notifications, setNotifications] = useState<NotifyResponse[]>([]);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const { username } = useContext(AuthContext);

  // Establish WebSocket connection for notifications
  useWebSocketNotifications(username, (data: NotifyResponse) => {
    setNotifications((prev) => [data, ...prev]);
  });

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setShowDropdown(false);
      }
    };
    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown]);

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  return (
    <div className="relative font-sans" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className="relative p-2 transition duration-200 rounded-full hover:text-white"
      >
        <FaBell className="text-lg text-gray-300 hover:text-white hover:scale-110" />
        {notifications.length > 0 && (
          <span className="absolute w-2 h-2 bg-red-500 rounded-full top-1 right-1" />
        )}
      </button>

      {showDropdown && (
        <div className="absolute right-0 z-50 p-4 mt-2 text-sm bg-white border rounded-lg shadow-lg w-96">
          <div className="p-2">
            <p className="font-semibold text-black text-[16px]">
              Notifications
            </p>
          </div>

          <hr className="my-2" />

          {notifications.length === 0 ? (
            <p className="text-center text-gray-500">No new notifications</p>
          ) : (
            <div
              className={`pr-2 space-y-2 ${
                notifications.length > 5
                  ? "overflow-y-auto max-h-96 custom-scrollbar"
                  : ""
              }`}
            >
              {notifications.map((notification, index) => (
                <div
                  key={index}
                  className="flex items-center w-full gap-4 p-4 rounded-md hover:bg-gray-100"
                >
                  <div className="flex items-center justify-center w-10 text-sm font-semibold text-white bg-red-400 rounded-full aspect-square">
                    {notification.userFName?.charAt(0).toUpperCase()}
                  </div>
                  <div className="flex flex-col gap-1">
                    <p className="text-xs font-semibold">
                      {notification.notificationMessage}
                      <br />
                      {/* <strong>
                        (Batch Number :
                        {notification.notifyBulkDetailsInfo?.[0]?.batchNumber})
                      </strong> */}
                    </p>
                    <p className="font-sans text-xs text-gray-500">
                      {notification.userFName}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}

          <hr className="my-2" />
          {/* <div>
            <Link to={ROUTES.INBOXNOTIFICATION}>
              <span className="w-full px-4 mx-auto text-xs font-semibold transition-all duration-500 hover:text-red-500">
                Select all notifications
              </span>
            </Link>
          </div> */}
        </div>
      )}
    </div>
  );
};

export default NotificationBell;
